// extracted by mini-css-extract-plugin
export default {"userInput":"render-user-input_userInput__w4Vmw","input":"render-user-input_input__9AmF6","sendBtn":"render-user-input_sendBtn__LA1W9"};